<template>
    <div>
      <el-card class="main_box-card" >
        <div slot="header" class="clearfix" >
          <h2>{{dataForm.name}}</h2>
          <span style="font-size: 14px;" >编辑：{{dataForm.auth}}&nbsp&nbsp&nbsp&nbsp 发布时间：{{dataForm.gmtCreate}}</span>
        </div>
        <div class="newsBox">
            <div v-html="dataForm.introduce"></div>
          
          <br>
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
  //这里可以导入其他文件（比如：组件，工具 js，第三方插件 js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import {getInfoById} from '../../../api/info.js'
  export default {
  //import 引入的组件需要注入到对象中才能使用
    components: {},
    props: {},
    data() {
      var validateContent = (rule, value, callback) => {
        if (!this.dataForm.content && !/\S/.test(value)) {
          callback(new Error('内容不能为空'))
        } else {
          callback()
        }
      }
      //这里存放数据
      return {
        param:{},
        dataList:[],
        dataForm:{
          id:'',
          name:'',
          auth:'',
          introduce:'',
          gmtCreate:''
        },
        pickerOptions: {},
  
      };
    },
  //计算属性 类似于 data 概念
    computed: {},
  //监控 data 中的数据变化
    watch: {},
  //方法集合
    methods: {
  
      //回填数据
      backDataDetail(){
        const id = this.$route.params.id
        console.log("从页面路径上获取下来的书本id是:",id);
        getInfoById(id).then((resp)=>{
          console.log("调用getInfoById接口返回的信息是:",resp.data);
          const {code,data} = resp.data
          if(code === '00000'){
            this.dataForm.id = data.id
            this.dataForm.name = data.name
            this.dataForm.auth = data.auth
            this.dataForm.introduce = data.introduce
            this.dataForm.gmtCreate = data.gmtCreate
          }
        })
      },
  
    },
  //生命周期 - 创建完成（可以访问当前 this 实例）
    created() {
      this.backDataDetail();
    },
  //生命周期 - 挂载完成（可以访问 DOM 元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有 keep-alive 缓存功能，这个函数会触发
  };
  </script>
  
  
  <style lang="less" scoped>
  .newsBox{
    text-align: start;
    margin: 8px;
    
  }
  .dialog-footer{
    margin-left: 70%;
  }
  h1 {
    font-size: 32px;
  }
  </style>
  